module.exports = ['RewardsContract', 'PaybeatsNFT', 'PaybeatsTracks']